// Filename: restricted-products.js


async function hasPractitionerDiscount(){
    const cart = await fetch('/cart.js').then(r => r.json());
    const hasDiscount = Array.isArray(cart.discount_codes) && cart.discount_codes.length > 0;

    return hasDiscount;
}

document.addEventListener('DOMContentLoaded', async () => {

  // Only run on cart page
  if (!window.location.pathname.includes('/cart')) return;

  const isLoggedIn = window.customer_logged_in === true;

  try {
    // Check if any cart item is restricted
    const restrictedLineKeys = [...document.querySelectorAll('.cart-item')]
      .filter(el => {
        const tags = el.dataset.productTags?.split(',') || [];
        return tags.includes('restricted');
      })
      .map(el => el.dataset.lineKey);

    if (restrictedLineKeys.length === 0) return;

    const hasDiscount = await hasPractitionerDiscount();

    if (isLoggedIn && hasDiscount) return;

    // Otherwise → block cart
    const cartBlocks = document.querySelector('.cart__blocks');
    if (!cartBlocks) return;

    if(!isLoggedIn){
      cartBlocks.innerHTML = `
        <div class="restricted-cart-message" style="
          padding: 32px;
          background: #f6f7f9;
          border-radius: 12px;
          text-align: center;
        ">
          <p style="font-size: 18px; font-weight: 600; margin-bottom: 12px;">
            You have restricted products in your cart
          </p>
          <p style="font-size: 14px;">
            Please log into your account and apply your practitioner discount
            to continue.
          </p>
          <p style="margin-top: 12px;">
            <a href="/account/login">Log in</a> or
            <a href="/account/register">Create an account</a>
          </p>
        </div>
      `;
    }else{
      cartBlocks.innerHTML = `
        <div class="restricted-cart-message" style="
          padding: 32px;
          background: #f6f7f9;
          border-radius: 12px;
          text-align: center;
        ">
          <p style="font-size: 18px; font-weight: 600; margin-bottom: 12px;">
            You have restricted products in your cart
          </p>
          <p style="font-size: 14px;">
            Please go to your account page and apply your practitioner discount
            to continue.
          </p>
          <p style="margin-top: 12px;">
            <a href="/account/">Go to my account page</a>
          </p>
        </div>
      `;
    }
  } catch (e) {
    console.warn('Restricted cart logic failed:', e);
  }
});
